import React from "react";

function PaymentHistory() {
  const history = [
    {
      id: "TXN-1001",
      date: "20 Aug 2026",
      description: "Java DSA Trainer Payment",
      amount: "₹40,000",
      method: "Bank Transfer",
      status: "SUCCESS",
    },
    {
      id: "TXN-1002",
      date: "15 Aug 2026",
      description: "Python Trainer Payment",
      amount: "₹35,000",
      method: "UPI",
      status: "SUCCESS",
    },
  ];

  return (
    <div className="page">
      <h1>Payment History</h1>
      <p>Complete transaction history.</p>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Transaction</th>
              <th>Date</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Method</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {history.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.date}</td>
                <td>{item.description}</td>
                <td>{item.amount}</td>
                <td>{item.method}</td>
                <td>
                  <span className="success">
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .page > p {
          color:#64748b;
        }

        .card {
          margin-top:25px;
          background:white;
          padding:20px;
          border-radius:12px;
          overflow:auto;
        }

        table {
          width:100%;
          border-collapse:collapse;
        }

        th,td {
          padding:13px;
          border-bottom:1px solid #e2e8f0;
          text-align:left;
          white-space:nowrap;
        }

        th {
          background:#f8fafc;
        }

        .success {
          background:#dcfce7;
          color:#166534;
          padding:5px 10px;
          border-radius:20px;
          font-size:11px;
          font-weight:bold;
        }
      `}</style>
    </div>
  );
}

export default PaymentHistory;